import { z } from 'zod/v4';
export const queryValidator = (shema) => (value) => {
    try {
        if (typeof value != 'string') {
            return false;
        }
        const parsed = JSON.parse(value);
        const res = shema.safeParse(parsed);
        return res.success;
    }
    catch (err) {
        return false;
    }
};
export const queryJSONSchema = (schema, error) => {
    return z
        .custom(queryValidator(schema), error)
        .transform((x) => JSON.parse(x));
};
//# sourceMappingURL=index.js.map